import React, { Component } from "react";
import { connect } from "react-redux";
import { Header } from "semantic-ui-react";
import PlotlyPie from "./../plotly/PlotlyPie";
import { InsightStyled, NoCircle } from "./style.js";
import _ from "lodash";
import clsx from "clsx";

class KeyDriverCircles extends Component {
  mapKeyDriversToPie(keyDriver, currentGroupName, prevGroupName) {
    const pieData = {};
    if (keyDriver && typeof keyDriver.data === "object") {
      // Figure out the indixes for percent positive, neutral, and negative
      let positiveIndex = -1;
      let neutralIndex = -1;
      let negativeIndex = -1;
      _.forEach(keyDriver.data, function(point, index) {
        if (point.name === "Percent Positive") {
          positiveIndex = index;
        } else if (point.name === "Percent Neutral") {
          neutralIndex = index;
        }
        if (point.name === "Percent Negative") {
          negativeIndex = index;
        }
      });

      let currentIndex = -1;
      let prevIndex = -1;
      _.forEach(keyDriver.data[0].data, function(point, index) {
        if (point.group_name === currentGroupName) {
          currentIndex = index;
        } else if (point.group_name === prevGroupName) {
          prevIndex = index;
        }
      });
      if (currentIndex === -1) {
        currentIndex = 0;
      }
      pieData.positive = keyDriver.data[positiveIndex].data[currentIndex].percent;
      if (neutralIndex > -1) {
        pieData.neutral = keyDriver.data[neutralIndex].data[currentIndex].percent;
      } else {
        pieData.neutral = 0;
      }
      pieData.negative = keyDriver.data[negativeIndex].data[currentIndex].percent;
      pieData.showPrevPositive = prevIndex >= 0;
      if (pieData.showPrevPositive) {
        pieData.prevPositive = keyDriver.data[positiveIndex].data[prevIndex].percent;
      }
    }
    return pieData;
  }

  canShowGraph(keyDriver, currentGroupName) {
    return (
      keyDriver &&
      typeof keyDriver.data === "object" &&
      keyDriver.data[0] &&
      (!currentGroupName ||
        _.filter(keyDriver && keyDriver.data[0].data, function(point) {
          return point.group_name === currentGroupName;
        }).length > 0)
    );
  }

  graphComponent = (currentGroupName, prevGroupName, column) => {
    const { keyDrivers, showInlineValuesOnDonuts } = this.props;
    const data = this.mapKeyDriversToPie(keyDrivers[column], currentGroupName, prevGroupName);
    const neutralLabelDeg = data.positive * 3.6 + data.neutral * 1.8;
    const flipNeutralLabel = neutralLabelDeg > 90 && neutralLabelDeg < 270;
    const negativeLabelDeg = data.negative * -1.8;
    const flipNegativeLabel = negativeLabelDeg < -90 && negativeLabelDeg > -270;
    return (
      <div className="donut-graph">
        {this.canShowGraph(keyDrivers[column], currentGroupName) ? (
          <div>
            <div className="circle-background" />
            {data.positive > 0 &&
              data.positive < 100 && (
                <div className="circle-arrow" style={{ transform: `rotate(${data.positive * 1.8}deg)` }}>
                  ▲
                </div>
              )}
            {showInlineValuesOnDonuts &&
              !!data.neutral &&
              data.neutral > 0 && (
                <div
                  className="circle-label"
                  style={{
                    transform: `rotate(${neutralLabelDeg + (flipNeutralLabel ? 180 : 0)}deg)`,
                    paddingTop: flipNeutralLabel ? "97px" : "",
                  }}
                >
                  {data.neutral}%
                </div>
              )}
            {showInlineValuesOnDonuts &&
              !!data.negative &&
              data.negative > 0 && (
                <div
                  className="circle-label"
                  style={{
                    transform: `rotate(${negativeLabelDeg + (flipNegativeLabel ? 180 : 0)}deg)`,
                    paddingTop: flipNegativeLabel ? "97px" : "",
                    color: "#fff",
                  }}
                >
                  {data.negative}%
                </div>
              )}
            <PlotlyPie data={data} />
          </div>
        ) : column === "instructions" ? (
          <div />
        ) : (
          <NoCircle>Insufficient number of responses to display results.</NoCircle>
        )}
      </div>
    );
  };

  render() {
    const { summaryReport, landscape } = this.props;
    const { survey, comparativeDatasets } = summaryReport;

    const surveyType = survey && survey.replace(/_Pulse/g, "");

    const currentDataset = _.filter(
      _.map(comparativeDatasets && comparativeDatasets.split("||"), function(dataset) {
        return { year: dataset.split("|")[0], id: dataset.split("|")[1] };
      }),
      function(dataset) {
        return dataset.id === "this";
      }
    )[0];
    const currentGroupName = currentDataset && currentDataset.year;
    const prevDataset = _.reduce(
      _.map(comparativeDatasets && comparativeDatasets.split("||"), function(dataset) {
        return { year: dataset.split("|")[0], id: dataset.split("|")[1] };
      }),
      function(highest, next) {
        return (highest.year < next.year || highest.id === "this") && next.id !== "this" ? next : highest;
      }
    );
    const prevGroupName = prevDataset && prevDataset.year;

    const circleGraphs = {
      instructions: {
        title: "",
        fullText:
          "These circle graphs show the percent positive (in green), percent neutral (in yellow), and percent negative (in red). Great responses will have a lot of green.",
        text:
          "These circle graphs show the percent positive (in green), percent neutral (in yellow), and percent negative (in red). Great responses will have a lot of green.",
        sutterText:
          "These circle graphs show the percent positive (in green), percent neutral (in yellow), and percent negative (in red). Great responses will have a lot of green.",
      },
      leinput: {
        title: "Improvement Readiness",
        fullText: "The learning environment utilizes input/suggestions from the people that work here.",
        text: "The learning environment utilizes input/suggestions.",
        sutterText: "Learning environment utilizes input.",
      },
      lefixdefct: {
        title: "Improvement Readiness",
        fullText: "The learning environment effectively fixes defects to improve the quality of what we do.",
        text: "The learning environment effectively fixes defects.",
        sutterText: "Learning environment fixes defects to improve quality.",
      },
      psyuseflfb: {
        title: "Local Leadership",
        fullText: "In this work setting, local leadership provides useful feedback about my performance.",
        text: "Provides useful feedback about my performance.",
      },
      psyposfb: {
        title: "Local Leadership",
        fullText: "Local Management regularly makes time to provide positive feedback to me about how I am doing.",
        text: "Regularly makes time to provide positive feedback to me.",
        sutterText: "Local management makes time to provide feedback.",
      },
      eeclmburn: {
        title: "Burnout Climate",
        fullText: "People in this work setting are burned out from their work.",
        text: "People in this work setting are burned out from their work.",
      },
      eemeburn: {
        title: "Personal Burnout",
        fullText: "I feel burned out from my work.",
        text: "I feel burned out from my work.",
      },
      spkupclt: {
        title: "Teamwork",
        fullText: "In this work setting, it is difficult to speak up if I perceive a problem with patient care.",
        text: "It is difficult to speak up if I perceive a problem.",
        sutterText: "Difficulty speaking up about patient care problem.",
      },
      diffcoll: {
        title: "Teamwork",
        fullText: "Dealing with difficult colleagues is consistently a challenging part of my job.",
        text: "Dealing with difficult colleagues is consistently a part of my job.",
      },
      comdelay: {
        title: "Teamwork",
        fullText: "Communication breakdowns are common in this work setting.",
        text: "Communication breakdowns are common in this work setting.",
        sutterText: "Communication breakdowns are common.",
      },
      cultlearn: {
        title: "Safety Climate",
        fullText: "The culture in this work setting makes it easy to learn from the errors of others.",
        text: "The culture makes it easy to learn from the errors of others.",
        sutterText: "Easy to learn from errors of others.",
      },
      feelsafe: {
        title: "Safety Climate",
        fullText: "I would feel safe being treated here as a patient.",
        text: "I would feel safe being treated here as a patient.",
        sutterText: "Would feel safe being treated here.",
      },
      nobreaks: {
        title: "Work / Life Balance",
        fullText: "Worked through a day/shift without any breaks.",
        text: "Worked through a day/shift without any breaks.",
      },
      goachieve: {
        title: "Growth Opportunities",
        fullText: "I have the feeling that I can achieve something.",
        text: "I have the feeling that I can achieve something.",
        sutterText: "Can achieve something.",
      },
      itlthnklv: {
        title: "Intentions to Leave",
        fullText: "I often think about leaving this job.",
        text: "I often think about leaving this job.",
      },
      ptdmmywork: {
        title: "Decision Making",
        fullText: "In this work setting, I can participate in decisions about the nature of my work.",
        text: "I can participate in decisions about my work.",
        sutterText: "Able to participate in decisions about my work.",
      },
      phys_safety: {
        title: "Physical Safety",
        fullText: "I feel safe from crime or violence in my (daily) workspace.",
        text: "I feel safe from crime or violence in my (daily) workspace.",
      },
      erhndlapp: {
        title: "Safety Climate",
        fullText: "Errors are handled appropriately in this work setting.",
        text: "Errors are handled appropriately in this work setting."
      },
      resolve: {
        title: "Teamwork",
        fullText: "Disagreements in this work setting are appropriately resolved.",
        text: "Disagreements in this work setting are appropriately resolved."
      },
      safeacted: {
        title: "Safety Climate",
        fullText: "My suggestions about quality would be acted upon if I expressed them to management.",
        text: "My suggestions about quality would be acted upon if I expressed them to management."
      },
      diffdiscuss: {
        title: "Safety Climate",
        fullText: "In this work setting, it is difficult to discuss errors.",
        text: "In this work setting, it is difficult to discuss errors."
      },
      valueshared: {
        title: "Safety Climate",
        fullText: "The values of leadership are the same values as people in this work setting have.",
        fullText: "Leadership & people in this work setting share the same important values.",
        text: "Leadership & people in this work setting share the same important values."
      },
      itllv1yr: {
        title: "Intentions to Leave",
        fullText: "I have plans to leave this job within the next year.",
        text: "I have plans to leave this job within the next year."
      }
    };

    let firstRowCircleGraphs = [];
    let secondRowCircleGraphs = [];
    let thirdRowCircleGraphs = [];
    let keyDriverRows;
    const keyDriversConfiguration =
      summaryReport &&
      summaryReport.configuration &&
      summaryReport.configuration.key_drivers &&
      summaryReport.configuration.key_drivers.rows;
    if (keyDriversConfiguration) {
      if (landscape && keyDriversConfiguration.landscape) {
        keyDriverRows = keyDriversConfiguration.landscape;
      }
      if (!landscape && keyDriversConfiguration.portrait) {
        keyDriverRows = keyDriversConfiguration.portrait;
      }
    }
    if (keyDriverRows) {
      firstRowCircleGraphs = keyDriverRows[0];
      secondRowCircleGraphs = keyDriverRows[1];
      if (keyDriverRows.length > 2)
        thirdRowCircleGraphs = keyDriverRows[2];
    } else if (/NonClinical/.test(summaryReport.actualSurvey)) {
      firstRowCircleGraphs = ["leinput", "lefixdefct", "psyposfb", "eeclmburn", "diffcoll"];
      secondRowCircleGraphs = ["comdelay", "cultlearn", "nobreaks", "goachieve", "itlthnklv"];
    } else if (/SUTTER_Pulse/.test(summaryReport.actualSurvey)) {
      if (/SUTTER_Pulse_PhysicianAcute/.test(summaryReport.actualSurvey)) {
        firstRowCircleGraphs = ["instructions", "lefixdefct", "leinput", "psyposfb", "comdelay"];
        secondRowCircleGraphs = ["spkupclt", "feelsafe", "cultlearn", "goachieve", "ptdmmywork"];
      } else if (/SUTTER_Pulse_PhysicianAmb/.test(summaryReport.actualSurvey)) {
        firstRowCircleGraphs = ["instructions", "spkupclt", "comdelay", "cultlearn", "feelsafe"];
      } else {
        firstRowCircleGraphs = ["instructions", "leinput", "lefixdefct", "psyposfb", "eemeburn"];
        secondRowCircleGraphs = ["cultlearn", "spkupclt", "comdelay", "feelsafe", "phys_safety"];
      }
    } else if (surveyType === "SELECT_2020") {
        firstRowCircleGraphs = ["lefixdefct", "psyposfb", "eeclmburn","eemeburn", "spkupclt"];
        secondRowCircleGraphs = [ "diffcoll", "comdelay", "cultlearn", "feelsafe", "nobreaks"];
    } else if (surveyType === "SCORE") {
      if (summaryReport.system === "NYU" && summaryReport.version.major > 1) {
        firstRowCircleGraphs = ["leinput", "lefixdefct", "psyposfb", "eeclmburn", "spkupclt"];
        secondRowCircleGraphs = ["diffcoll", "comdelay", "cultlearn", "feelsafe", "ptdmmywork"];
      } else {
        firstRowCircleGraphs = ["lefixdefct", "psyposfb", "eeclmburn", "diffcoll", "comdelay"];
        secondRowCircleGraphs = ["cultlearn", "feelsafe", "nobreaks", "goachieve", "itlthnklv"];
      }
    } else if (surveyType === "SCOR") {
      if (summaryReport.system === "AMITA") {
        firstRowCircleGraphs = ["leinput", "lefixdefct", "psyuseflfb", "psyposfb", "eeclmburn"];
        secondRowCircleGraphs = ["spkupclt", "diffcoll", "comdelay", "cultlearn", "feelsafe"];
      } else if (survey.indexOf("Pulse") < 0) {
        firstRowCircleGraphs = ["lefixdefct", "psyposfb", "eeclmburn", "eemeburn", "spkupclt"];
        secondRowCircleGraphs = ["diffcoll", "comdelay", "cultlearn", "feelsafe", "nobreaks"];
      } else {
        firstRowCircleGraphs = ["leinput", "lefixdefct", "psyposfb", "eeclmburn", "spkupclt"];
        secondRowCircleGraphs = ["diffcoll", "comdelay", "cultlearn", "feelsafe", "nobreaks"];
      }
    } else if (surveyType === "VALLEY_2020") {
      firstRowCircleGraphs = ["leinput", "lefixdefct", "psyposfb", "eeclmburn", "eemeburn"];
      secondRowCircleGraphs = ["spkupclt", "diffcoll", "comdelay", "cultlearn", "feelsafe"];
    }

    const breathingRoom = surveyType === "SCORE" || landscape ? "" : "breathing-room";

    const questions = summaryReport.surveyQuestions && _.keyBy(summaryReport.surveyQuestions, "column");

    function getTitle(column) {
      const question = questions[column];
      if (question && question.domainText) {
        return question.domainText;
      } else {
        if (!circleGraphs[column]) {
          console.log(`Missing data for question ${column}`);
          return "";
        }
        return circleGraphs[column].title;
      }
    }

    const sutter2018 = _.includes(
      ["SUTTER_Pulse", "SUTTER_Pulse_PhysicianAcute", "SUTTER_Pulse_PhysicianAmb"],
      summaryReport.actualSurvey
    );

    function getText(column) {
      const question = questions[column];
      if (question && question.keyDriverText) {
        return question.keyDriverText;
      } else {

        if (!circleGraphs[column]) {
          console.log(`Missing data for question ${column}`);
          return "";
        }
        

        return sutter2018
          ? summaryReport.actualSurvey === "SUTTER_Pulse_PhysicianAcute"
            ? circleGraphs[column].sutterText
            : circleGraphs[column].text.replace("my work", "work")
          : circleGraphs[column].text;
      }
    }

    const keyDriver = column => {
      return (
        <div className="keyDriver" key={column}>
          <Header as="h3">{getTitle(column)}</Header>
          <p className={column}>{getText(column)}</p>
          {this.graphComponent(currentGroupName, prevGroupName, column)}
        </div>
      );
    };

    // New variable needed to account for SCORE reports with custom templates
    var surveyTypeTitleKey = surveyType;
    if (summaryReport.configuration && summaryReport.configuration.survey_type) 
    {
      surveyTypeTitleKey = summaryReport.configuration.survey_type;
    }

    return (
      <InsightStyled className={clsx(breathingRoom, { landscape })}>
        <Header as="h2">Key Drivers of Culture{surveyTypeTitleKey === "SCORE" ? " & Engagement" : ""}</Header>
        <Header as="h3" style={{ display: "inline", fontSize: "16px", textTransform: "none" }}>
          {" "}
          (Green is good)
        </Header>
        <div className="keyDrivers">{_.map(firstRowCircleGraphs, column => keyDriver(column))}</div>
        <div className="keyDrivers">{_.map(secondRowCircleGraphs, column => keyDriver(column))}</div>
        {thirdRowCircleGraphs.length > 0 && <div className="keyDrivers">{_.map(thirdRowCircleGraphs, column => keyDriver(column))}</div>}        
      </InsightStyled>
    );
  }
}

export default connect(store => {
  return {
    summaryReport: store.summaryReport.summaryReport,
    keyDrivers: store.keyDrivers.keyDrivers,
  };
})(KeyDriverCircles);



// WEBPACK FOOTER //
// ./src/components/KeyDriverCircles/index.jsx